module.exports = __webpack_public_path__ + "static/media/building.31a7d5d7.svg";